import { Component, OnInit } from "@angular/core";
import packageJson from "../../../../package.json";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"]
})
export class FooterComponent implements OnInit {
  currentYear: number;
  version: string;
  constructor() {
    this.currentYear = new Date().getFullYear();
    this.version = packageJson.version;
  }

  ngOnInit() {}
}
